export function idvRouteForStep(currentOnboardingStep) {
  switch (currentOnboardingStep) {
    case "identityVerificationStep":
      return "/verify-identity";
    case "piiConfirmationStep":
      return "/confirm-identity";
    case "contactUsStep":
      return "/contact-support";
    default:
      return null;
  }
}

// The single route a terminally-declined prospect may reach.
export const TERMINAL_ROUTE = "/contact-support";

/**
 * Keyed on `isIdVerificationDeclined` and deliberately NOT on
 * `currentOnboardingStep === "contactUsStep"` — the backend maps both `declined` (terminal) and
 * `markedForReview` (not terminal) to that step, so gating on the step would lock a
 * needs-review prospect out of every route in the portal.
 */
export function isIdVerificationTerminal(user) {
  return user?.isIdVerificationDeclined === true;
}

export const stepAllowedNext = {
  piiConfirmationStep: [
    { path: "/contact-support", query: { reason: "pii-incorrect" } },
    { path: "/contact-support", query: { reason: "extraction-failed" } },
  ],
  nliApplicationStep: [
    { path: "/contact-support", query: { reason: "pii-incorrect" } },
  ],
};

export function authenticatedLandingPath(user) {
  if (!user) return "/open-account";
  if (user.isOnboardingCompleted) return "/home";
  // Sends a declined prospect to /contact-support even when arriving from an anonymous route
  // (/ or /login). See isIdVerificationTerminal for why this is not keyed on currentOnboardingStep.
  if (isIdVerificationTerminal(user)) return TERMINAL_ROUTE;
  return "/open-account";
}

// Returns { action: "next" } or { action: "redirect", path }
export function resolveConfirmIdentityAccess(user) {
  const step = user.currentOnboardingStep;
  // Allowed on the live piiConfirmationStep (IDV approved, PII not yet
  // confirmed) AND as a genuinely-verified read-only revisit once IDV is
  // complete (nliApplicationStep + verified). Unverified nliApplicationStep
  // (submitted without IDV) is redirected back into the wizard.
  const allowed =
    step === "piiConfirmationStep" ||
    (step === "nliApplicationStep" && user.isIdentityVerified === true);
  if (allowed) return { action: "next" };
  if (step === "nliApplicationStep")
    return { action: "redirect", path: "/apply-account" };
  return {
    action: "redirect",
    path: idvRouteForStep(step) || authenticatedLandingPath(user),
  };
}
